export const LOCAL_STORAGE_CARTS = "LOCAL_STORAGE_CARTS";
export const LOCAL_STORAGE_INFORMATION_CART = "LOCAL_STORAGE_INFORMATION_CART";
export const LOCAL_STORAGE_TOKEN = "LOCAL_STORAGE_TOKEN";
export const ERROR_MESSAGE = {
  TEXT_FIELD_REQUIRED: "Trường này là không được để trống.",
  TEXT_FIELD_EMAIL: "Trường này phải có định dạng Email",
  TEXT_FIELD_PHONE_NUMBER: "Trường này phải có định dạng số điện thoại",
};

export const PAYMENT_METHOD = [
  {
    key: "PAYMENT_METHOD_OFFICE",
    value: "1",
    name: "Thanh toán khi nhận hàng",
  },
  {
    key: "PAYMENT_METHOD_ONLINE",
    value: "2",
    name: "Thanh toán qua thẻ ngân hàng nội địa",
  },
];
